export const translation = {
  nav: {
    home: 'Accueil',
    categories: 'Catégories',
    spreadsheet: 'Tableur',
    review: 'Avis',
    shipping: 'Livraison',
    coupon: 'Coupon',
    warehouse: 'Entrepôt',
    legit: 'Est-ce Légitime?',
    guide: 'Guides',
    blog: 'Blog',
    about: 'À propos',
    contact: 'Contact',
    language: 'Langue',
  },
  hero: {
    eyebrow: 'HUB DE RESSOURCES TABLEUR ALLCHINABUY',
    h1: 'Tableur AllChinaBuy — Trouvez des Produits, Vendeurs & Guides d\'Achat',
    description: 'Découvrez des ressources utiles sur le tableur AllChinaBuy, des trouvailles de produits, des informations sur les vendeurs, des guides QC, des conseils de livraison, des avis et des ressources d\'achat — organisés dans un hub facile à rechercher.',
    ctaPrimary: 'Explorer le Tableur AllChinaBuy',
    ctaSecondary: 'Parcourir les Catégories de Produits',
    trustLine: 'Ressource Indépendante • Guides à Jour • Multilingue • Axé sur la Recherche',
  },
  search: {
    h2: 'Trouver une Ressource du Tableur AllChinaBuy',
    placeholder: 'Rechercher des produits, vendeurs, tableurs, QC, livraison ou guides...',
    button: 'Rechercher des Ressources',
    popular: 'Populaire :',
    tags: 'Tableur • Chaussures • Vêtements • QC • Livraison • Avis • Coupon',
  },
  categories: {
    h2: 'Catégories Populaires du Tableur AllChinaBuy',
    subtitle: 'Explorez les catégories de produits et trouvez ce dont vous avez besoin via le tableur AllChinaBuy.',
    shoes: 'Chaussures',
    hoodies: 'Sweats à Capuche/Pulls',
    tshirts: 'T-Shirts',
    jackets: 'Vestes',
    pants: 'Pantalons/Shorts',
    headwear: 'Couvre-Chefs',
    sets: 'Ensembles',
    underwear: 'Sous-vêtements/Caleçons',
    jersey: 'Maillots',
    accessories: 'Accessoires',
    bags: 'Sacs',
    belts: 'Ceintures',
    perfumes: 'Parfums',
    other: 'Autres Articles',
    viewAll: 'Voir Toutes les Catégories',
  },
  value: {
    h2: 'Tout ce Dont Vous Avez Besoin pour Rechercher AllChinaBuy en un Seul Endroit',
    description: 'Rechercher parmi des liens de produits éparpillés, des listes de vendeurs et des guides d\'achat peut prendre du temps. Notre objectif est d\'organiser les informations utiles sur AllChinaBuy en catégories claires pour que vous puissiez rechercher des produits, comprendre le QC, comparer les options de livraison et prendre des décisions d\'achat plus éclairées.',
    cards: {
      spreadsheet: { title: 'Ressources de Tableur', desc: 'Explorez des ressources de tableur organisées et des guides de découverte de produits.' },
      seller: { title: 'Recherche de Vendeurs', desc: 'Apprenez à évaluer les informations des vendeurs et les listes de produits.' },
      qc: { title: 'Guides QC', desc: 'Comprenez les photos QC, les facteurs de qualité et les problèmes courants.' },
      shipping: { title: 'Guides de Livraison', desc: 'Apprenez les méthodes de livraison, les coûts et les facteurs de livraison.' },
      reviews: { title: 'Avis & Comparaisons', desc: 'Comparez les facteurs importants avant de prendre une décision.' },
      safety: { title: 'Centre de Sécurité', desc: 'Comprenez les risques d\'achat, de paiement, de vendeur et de livraison.' },
    },
  },
  review: {
    h2: 'Avis AllChinaBuy',
    description: 'Vous cherchez un aperçu indépendant ? Explorez notre avis AllChinaBuy couvrant l\'achat, la livraison, les processus d\'entrepôt, la recherche de vendeurs et les risques courants.',
    cta: 'Lire l\'Avis AllChinaBuy',
  },
  shipping: {
    h2: 'Coût de Livraison & Guide de Livraison AllChinaBuy',
    description: 'La livraison peut varier selon la destination, la taille du colis, le poids, la méthode de livraison et les conditions du transporteur. Apprenez quels facteurs peuvent influencer les coûts de livraison et les délais de livraison AllChinaBuy.',
    cta: 'Voir le Guide de Livraison',
  },
  coupon: {
    h2: 'Coupon & Code de Réduction AllChinaBuy',
    description: 'Vous cherchez des coupons ou codes de réduction AllChinaBuy actuels ? Consultez notre dernière page de ressources et distinguez clairement les offres vérifiées, non vérifiées et expirées.',
    cta: 'Vérifier les Offres Actuelles',
  },
  warehouse: {
    h2: 'Guide de l\'Entrepôt AllChinaBuy',
    description: 'Apprenez comment le stockage d\'entrepôt, le QC, la consolidation de colis et la préparation de livraison peuvent affecter le processus d\'achat.',
    cta: 'Explorer le Guide de l\'Entrepôt',
  },
  legit: {
    h2: 'AllChinaBuy est-il Légitime?',
    description: 'Avant d\'utiliser une plateforme d\'achat ou d\'agent, comprenez les risques de vendeur, les considérations de paiement, la qualité des produits, la livraison et les procédures de litige.',
    cta: 'Lire le Guide de Sécurité & Légitimité',
  },
  finalCta: {
    h2: 'Prêt à Explorer le Tableur AllChinaBuy?',
    description: 'Commencez par le tableur, explorez les catégories de produits, lisez les derniers guides et apprenez à rechercher des produits, des vendeurs, du QC et de la livraison plus efficacement.',
    ctaPrimary: 'Explorer le Tableur AllChinaBuy',
    ctaSecondary: 'Lire les Guides d\'Achat',
  },
  mainSite: {
    title: 'Tableur AllChinaBuy',
    button: 'Acheter Maintenant',
    description: 'Explorez le tableur AllChinaBuy complet sur notre site principal pour le catalogue de produits complet.',
  },
  footer: {
    tagline: 'Hub de Ressources Indépendant Tableur AllChinaBuy',
    resources: 'Ressources',
    spreadsheet: 'Tableur',
    categories: 'Catégories',
    review: 'Avis',
    shipping: 'Livraison',
    coupon: 'Coupon',
    warehouse: 'Entrepôt',
    legit: 'Est-ce Légitime?',
    guides: 'Guides',
    company: 'Entreprise',
    about: 'À propos',
    contact: 'Contact',
    privacy: 'Politique de Confidentialité',
    terms: 'Conditions de Service',
    disclaimer: 'Avertissement',
    editorial: 'Politique Éditoriale',
    rights: 'Tous droits réservés.',
    disclaimerText: 'Ce site fournit des informations éducatives générales. Il ne garantit pas la qualité des vendeurs, l\'authenticité des produits, les résultats de livraison, les remboursements ou les résultats de transaction.',
  },
  languages: {
    en: 'English',
    fr: 'Français',
    de: 'Deutsch',
    da: 'Dansk',
  },
  common: {
    readMore: 'Lire la Suite',
    learnMore: 'En Savoir Plus',
    explore: 'Explorer',
    backToHome: 'Retour à l\'Accueil',
    notFound: 'Page Non Trouvée',
    notFoundDesc: 'La page que vous recherchez n\'existe pas.',
  },
  meta: {
    siteName: 'Hub Tableur AllChinaBuy',
    homeTitle: 'Tableur AllChinaBuy 2026 — Produits, Vendeurs & Guides d\'Achat',
    homeDesc: 'Explorez le Tableur AllChinaBuy pour des trouvailles de produits, des ressources de vendeurs, des guides QC, des informations de livraison, des avis, des coupons et des conseils pratiques d\'achat.',
  },
};